<template>
    <div class="d-flex flex-row flex-wrap gap-1 align-items-center">
        <img v-if="runner.identite.nation != ''" class="flag-entete-coureur"
            :src="'https://sportips.fr/live/img/Flags/' + runner.identite.nation + '.jpg'" />
        <h3 class="m-0">
            <span>{{ runner.identite.prenom }} {{ runner.identite.nom }}</span>
            <b> | </b>
            <span>{{ $t("doss") }} n°
                <span class="primary_color m-0">{{ runner.identite.dossard }}</span>
            </span>
        </h3>
    </div>
</template>

<script>
export default {
    props: ["runner"],
}
</script>

<style lang="scss">
.flag-entete-coureur {
    width: auto;
    height: 15px;
    margin-bottom: 3px;
    border-radius: 3px;
}
</style>